module.exports = __webpack_public_path__ + "img/emoji-angry.845a8a0c.svg";